// extracted by css-extract-rspack-plugin
export default {"toastNotificationContainer":"toastNotificationContainer-PLV1x7"};